import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClientWH } from '@shared/services/ApiClient';
import { createHttpClient } from '@adapters/HttpClient';
import { useMemo } from 'react';
import { CartApiAdapter } from '../adapters/CartApiAdapter';
import { CartService } from '../services/CartService';

interface UpdateCartData {
  id: number;
  code: string;
  type_id: number;
}

export const useUpdateCart = () => {
  const queryClient = useQueryClient();

  const cartService = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CartApiAdapter(httpClient);
    return new CartService(apiAdapter);
  }, []);

  return useMutation({
    mutationFn: (data: UpdateCartData) =>
      cartService.updateCart(data.id, {
        code: data.code,
        type_id: data.type_id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['carts'] });
    },
  });
};
